import { createDetailReducer } from '../../../common/services/reducerCreator';

export default createDetailReducer({
  modelName: 'PRODUCT',
  inside: {
    club: { get: 'products', set: 'product' },
    player: { get: 'products', set: 'product' },
  },
});
